import apiClient from "../../axios/apiClient";

export const getScheduleBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_SCHEDULE_BOOKING_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/schedule-booking`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_SCHEDULE_BOOKING_LIST_FULFILLED",
        payload: response.data?.data,
        scheduleBookingCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_SCHEDULE_BOOKING_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveScheduleBookingData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_SCHEDULE_BOOKING_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/schedule-booking`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_SCHEDULE_BOOKING_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_SCHEDULE_BOOKING_REJECTED", payload: error.response });
    }
  };
  

  export const getScheduleBookingListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_SCHEDULE_BOOKING_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/schedule-booking/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_SCHEDULE_BOOKING_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_SCHEDULE_BOOKING_LISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateScheduleBookingData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_PENDING" });

    const response = await apiClient.put(
      `/api/v1/schedule-booking/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_REJECTED", payload: error.response });
  }
};


export const updateScheduleBookingStatusData = (token, id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Schedule-Booking-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_SCHEDULE_BOOKING_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteScheduleBookingData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_SCHEDULE_BOOKING_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/schedule-booking/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_SCHEDULE_BOOKING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_SCHEDULE_BOOKING_REJECTED", payload: error.response });
  }
};
